import { useQuery } from 'react-query'
import { FinancialAssistanceApi } from 'src/api/client'
import { FETCH_FINANCIAL_ASSISTANCE_PROGRAMS } from 'src/constants/queries'
import { IFinancialAssistanceProgram } from 'src/models/financialAssistance'

export const useFinancialAssistancePrograms = () => {
  const query = useQuery<{ programs: IFinancialAssistanceProgram[] }>({
    queryKey: FETCH_FINANCIAL_ASSISTANCE_PROGRAMS,
    queryFn: () => FinancialAssistanceApi.getFinancialAssistancePrograms()
  })

  return { ...query, programs: query.data ? query.data.programs : [] }
}
